import { useEffect } from "react"
import { Grid } from "@material-ui/core"
import { useDispatch, useSelector } from "react-redux"
import { closeEditarOfertaPaqueteAction, closeModalOfertaPaqueteAction, obtenerOfertasPaqueteAction } from "./../../../ducks/ofertasPaqueteDuck"
import { offLoadAction, onLoadAnction } from "./../../../ducks/loadDuck"
import HeaderModal from "./../../../global/headerModal"
import ModalBase from "./../../../global/ModalBase"
import { makeStyles } from "@material-ui/core"
import FormOferta from "./FormOferta"
import TablaOfertas from "./TablaOfertas"

export const FPaquetesOfertasStyle = makeStyles((theme) => ({
    textField: {
        width: '90%',
        margin: "5px",
        paddingBottom: 0,
        fontWeight: 500
    },
    textFieldMultiLinea: {
        width: '95%',
        margin: "5px",
        paddingBottom: 0,
        fontWeight: 500
    },
    formControl: {
        width: "97%",
        margin: "5px"
    },
    containerSpacing: {
        margin: "10px 5px",
        padding: "10px 10px"
    },
    containerSpacingItem: {
        margin: "10px 10px"
    },
    modalBotonesCenter: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    modalBotones: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    modalBoton: {
        margin: "15px 10px",
        width: "20%"
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        maxWidth: "1200px",
        margin: "0 auto",
        padding: theme.spacing(1),
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: 'none',
        boxShadow: theme.shadows[10],
        padding: theme.spacing(1, 2, 1),
        minWidth: "90%",
    },
}))

const FPaqueteOfertas = () => {
    const dispatch = useDispatch()
    const { openModal, clavePaquete } = useSelector(store => store.ofertasPaquete)
    const classes = FPaquetesOfertasStyle()

    useEffect(() => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerOfertasPaqueteAction({ clavePaquete })).then(Response => {
            dispatch(offLoadAction())
        })
    }, [dispatch, clavePaquete])

    const ToggleModal = () => {
        dispatch(closeModalOfertaPaqueteAction())
        dispatch(closeEditarOfertaPaqueteAction())
    }
    return (
        <ModalBase
            classes={classes}
            open={openModal}
            onClose={ToggleModal}
        >
            <HeaderModal titulo={`Ofertas extraordinarios paquete`} handleClose={ToggleModal} />
            <Grid container className={classes.containerSpacing}>
                <Grid xs={4}>
                    <div style={{ padding: "0.5rem" }}>
                        <FormOferta />
                    </div>
                </Grid>
                <Grid xs={8}>
                    <div style={{ padding: "0.5rem" }}>
                        <TablaOfertas />
                    </div>
                </Grid>
            </Grid>
        </ModalBase>
    )
}
export default FPaqueteOfertas
